import { ref, onUnmounted } from 'vue';
import { io } from 'socket.io-client';

// Якщо VITE_SOCKET_URL порожній — підключаємося до поточного сайту (продакшн)
const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || 'http://localhost:5000';

let socket = null;

export function useSocket() {
  const connected = ref(false);

  function connect() {
    if (socket && socket.connected) return;

    // У продакшні підключаємося до поточного origin
    const url = import.meta.env.VITE_SOCKET_URL !== undefined && import.meta.env.VITE_SOCKET_URL === ''
      ? window.location.origin
      : SOCKET_URL;

    socket = io(url, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000
    });

    socket.on('connect', () => {
      connected.value = true;
    });

    socket.on('disconnect', () => {
      connected.value = false;
    });
  }

  function disconnect() {
    if (socket) {
      socket.disconnect();
      socket = null;
      connected.value = false;
    }
  }

  function joinOrderRoom(orderId) {
    if (!socket) connect();
    socket.emit('join-order', orderId);
  }

  function leaveOrderRoom(orderId) {
    if (socket) {
      socket.emit('leave-order', orderId);
    }
  }

  function onOrderStatusUpdate(callback) {
    if (!socket) connect();
    socket.on('order:status-updated', callback);
  }

  function offOrderStatusUpdate(callback) {
    if (socket) {
      socket.off('order:status-updated', callback);
    }
  }

  // --- ЧАТ З МАЙСТРОМ ---
  function joinChatRoom(sessionId) {
    if (!socket) connect();
    socket.emit('join-chat', sessionId);
  }

  function onChatReply(callback) {
    if (!socket) connect();
    socket.on('chat:reply', callback);
  }

  function offChatReply(callback) {
    if (socket) socket.off('chat:reply', callback);
  }

  onUnmounted(() => {
    // Не отключаем сокет глобально — только снимаем слушатели
  });

  return {
    connected,
    connect,
    disconnect,
    joinOrderRoom,
    leaveOrderRoom,
    onOrderStatusUpdate,
    offOrderStatusUpdate,
    joinChatRoom,
    onChatReply,
    offChatReply
  };
}
